import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "offerings", label: "What I Offer" },
  { id: "highlights", label: "Highlights" },
  { id: "contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#2D2A26] bg-[#121110] text-[#8C857B]"
    >
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div>
            <img
              data-testid="footer-brand-logo"
              src="/saath-logo.png"
              alt="SAATH Trainings logo"
              className="mb-4 h-14 w-14 rounded-full bg-white object-contain p-1"
            />
            <p className="font-display text-lg font-bold tracking-[0.14em] text-[#FAF7F2]">
              SAATH TRAININGS
            </p>
            <p className="mt-2 text-sm">Founded by Husain M</p>
          </div>
          <nav data-testid="footer-nav" className="flex flex-wrap gap-x-6 gap-y-3">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`footer-link-${l.id}`}
                onClick={() => scrollToId(l.id)}
                className="text-sm transition-colors hover:text-[#FAF7F2]"
              >
                {l.label}
              </button>
            ))}
          </nav>
        </div>

        <div
          data-testid="footer-disclaimer-box"
          className="mt-10 rounded-xl border border-[#2D2A26] bg-[#1C1B1A] p-5 sm:p-6"
        >
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#E05A10] sm:text-xs">
            Disclaimer
          </p>
          <p className="mt-2 text-xs leading-relaxed sm:text-sm">
            SAATH Trainings and Husain M provide stock market and options
            trading education for instructional and informational purposes only.
            Trading in stock and derivatives markets carries inherent financial
            risk. No returns or profits are guaranteed. Please consult a
            certified financial advisor before making investment decisions.
          </p>
        </div>

        <p className="mt-8 text-xs">© 2026 SAATH Trainings. All rights reserved.</p>
      </div>
    </footer>
  );
}
